import i18next from 'i18next';
import { DateTime } from 'luxon';

export function getStatisticFormatedDate(currentDate: Date, format: string) {
  return DateTime.fromJSDate(currentDate)
    .setLocale(i18next.language)
    .toFormat(format);
}
